"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function array(value) {
    return Array.isArray(value) ? value : [value];
}
var Select = function (_a) {
    var id = _a.id, className = _a.className, name = _a.name, value = _a.value, children = _a.children, onChange = _a.onChange, disabled = _a.disabled, _b = _a.multiple, multiple = _b === void 0 ? false : _b;
    return react_1.default.createElement("select", { multiple: multiple, id: id, name: name, value: !multiple && !Array.isArray(value) ? value || '' : array(value), onChange: function (event) {
            if (!multiple) {
                return onChange(event.target.value);
            }
            var options = event.target.options;
            var values = [];
            for (var i in options) {
                if (options[i].selected) {
                    values.push(options[i].value);
                }
            }
            onChange(values);
        }, className: "storybook-forms-select" + (className ? " " + className : ''), disabled: disabled }, children);
};
exports.Select = Select;
exports.Select.propTypes = {
    /**
     * The id of the Select
     */
    id: prop_types_1.default.string,
    /**
     * The name of the Select
     */
    name: prop_types_1.default.string,
    /**
     * The options inside of the Select
     */
    children: prop_types_1.default.any,
    /**
     * The onChange function of the Select
     */
    onChange: prop_types_1.default.func,
    /**
     * The value of the Select
     */
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.number,
        prop_types_1.default.string,
        prop_types_1.default.array,
    ]),
};
exports.Select.defaultProps = {};
